import React from 'react';

const AgencyName = ({agency, className=''}) => {
    return (
        <span className={className}>{agency?.public_name ? agency?.public_name : agency?.name}</span>
    );
};

export default AgencyName;
